import { Injectable } from '@angular/core';
import {CrudService} from '../../services';
import {CreateCardBatchItem, CreateCardBatchListItem} from '../../models/create-card/create-card';
import {Observable} from 'rxjs';
import {DataListModel} from '../../models/data-list-model';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Order, OrderWithIdent} from '../../dto/order';
import {toServerDateString} from '../../providers/app-date-adapter';

@Injectable({
  providedIn: 'root'
})
export class CreateCardService implements CrudService<CreateCardBatchListItem>{



  readonly apiPath = 'orders/create-card-batch/';

  constructor(private http: HttpClient) { }

  get(id: any) {
    return this.http.get(this.apiPath + id) as Observable<CreateCardBatchItem>;
  }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData?: string[],
    enumFilter?: { key: string; value: string},
    companiesFilter?: string[]

  ): Observable<DataListModel<CreateCardBatchListItem>> {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
      .set('startFilterDate', toServerDateString(startFilterDate))
      .set('endFilterDate', toServerDateString(endFilterDate))
      .set('someAdditionalData', someAdditionalData);

    if (companiesFilter instanceof Array) {
      companiesFilter.forEach(element => {
        params = params.append('companiesFilter', element);
      });
    }

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }
    if (additionalFilterData instanceof Array) {
      additionalFilterData.forEach(element => {
        params = params.append('additionalFilterData', element);
      });
    }
    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }

    //return this.http.get(this.apiPath, { params }) as Observable<DataListModel<OrderWithIdent>>;
    // solr
    return this.http.get(this.apiPath, { params }) as Observable<DataListModel<CreateCardBatchListItem>>;
  }

  add(item: CreateCardBatchItem): Observable<Object> {
    return undefined;
  }

  delete(id: any): Observable<Object> {
    return undefined;
  }

  deleteMany(list: any[]): Observable<Object> {
    return undefined;
  }


  restore(id: any): Observable<Object> {
    return undefined;
  }

  restoreMany(list: any[]): Observable<Object> {
    return undefined;
  }

  update(id: any, item: CreateCardBatchItem): Observable<Object> {
    return undefined;
  }
}
